import { http } from './config'
import axios from 'axios'

export default {
    listar: (data) => {
        // const queryParams = `clienteId=${data.clienteId ? data.clienteId : ''}
        // &dataInicio=${data.dataInicio ? data.dataInicio : ''}
        // &dataInicio=${data.dataInicio ? data.dataInicio : ''}
        // &dataFim=${data.dataFim ? data.dataFim : ''}
        // &status=${data.status ? data.status : ''}
        // &tecnicoId=${data.tecnicoId ? data.tecnicoId : ''}
        // &cliente=${data.cliente ? data.cliente : ''}
        // &referencia=${data.referencia ? data.referencia : ''}
        // &limit=${data.limit ? data.limit : ''}
        // &page=${data.page ? data.page : 1}
        // `
        return http.get(`/v1/ordens-servicos`, {params: data})
    },
    salvar: (ordem) => {
        return http.post('/v1/ordens-servicos', ordem)
    },
    visualizar: (id) => {
        return http.get(`/v1/ordens-servicos/${id}`)
    },
    atualizar: (ordem) => {
        return http.put(`/v1/ordens-servicos/${ordem.id}`, ordem)
    },
    excluir: (data) => {
        return http.delete(`/v1/ordens-servicos/${data.id}?motivo_exclusao=${data.motivo_exclusao}`)
    },
    getCep(cep) {
        return axios.get(`https://viacep.com.br/ws/${cep}/json/`)
    },
    imprimir(data){
        return http.get(`/v1/ordem-servico/${data.id}/imprimir?modelo_impressao=${data.modelo_impressao}`)
    },
    relatorioPorPeriodo(data){
        const queryParam = `periodo_inicial=${data.periodo_inicial ? data.periodo_inicial : ''}
        &periodo_final=${data.periodo_final ? data.periodo_final : ''}
        &tecnicoId=${data.tecnicoId ? data.tecnicoId : ''}
        &status=${data.status ? data.status : ''}
        `
        return http.get(`/v1/ordem-servico/relatorio?${queryParam}`, {params : data})
    },
    pagamento(data){
        return http.post(`/v1/ordem-servico/pagamento`, data)
    }
}